import React from "react";
import * as PropTypes from "prop-types";
import ItemChooser from "./ItemChooser";

const MethodChooser = props => {
  let items = [
    {
      value: "-1",
      label: "All methods"
    }
  ];

  if (props.allowMix) {
    items = [
      ...items,
      {
        value: "-2",
        label: "Method mix"
      }
    ];
  }

  items = [
    ...items,
    ...[5, 3, 4, 6, 7, 8, 2].map(key => ({
      value: key.toString(),
      label: props.methods[key]
    }))
  ];

  return (
    <ItemChooser
      id={props.id}
      label={props.label}
      items={items}
      value={props.selectedKey ? props.selectedKey.toString() : "-1"}
      onChange={value => {
        props.onChange(value === "-1" ? undefined : parseInt(value, 10));
      }}
    />
  );
};

MethodChooser.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  methods: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  selectedKey: PropTypes.number,
  allowMix: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

MethodChooser.defaultProps = {
  label: "Select Method",
  allowMix: false
};

export default MethodChooser;
